import React, { useEffect, useState } from "react";
import Header from "../Components/TeacherDashboard/Header";
import PaginationData from "../Components/TeacherDashboard/PaginationData";
import Sidebar from "../Components/TeacherDashboard/Sidebar";
import { HStack, Box, Center, VStack, Divider, Button,Text} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ScholarshipAdd from "../Components/TeacherDashboard/ScholarshipAdd";
import ScholarshipModal from "../Components/TeacherDashboard/ScholarshipModal";
import axios from "axios"
import NotesAdd from "../Components/TeacherDashboard/NotesAdd";
import AlumniAdd from "../Components/TeacherDashboard/AlumniAdd";
import Results from "../Components/TeacherDashboard/Results";

function TeacherDashboard() {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
 const [studentcount,setStudentCount]=useState(0)
 useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/studentcount`);
      setStudentCount(res.data.count);
      
      const existingToken = localStorage.getItem("sbpathshalaAdmin");
      if (existingToken) {
        navigate("/teachers/dashboard");
      } else {
        navigate("/");
      }
    } catch (error) {
      // Handle error if the API request fails
      console.error("Error fetching data:", error);
    }
  };

  fetchData(); // Call the async function

  // Note: If you need to include a cleanup function, you can return it here.
  // For example:
  // return () => {
  //   // Cleanup code here
  // };
}, []); // The empty dependency array ensures that this effect runs only once on mount

  return (
    <>
      <div style={{ width: "100%", display: "flex"}} >
        <div style={{ width: "10%" }}>
          <Sidebar />
        </div>
        <div style={{ width: "90%" }}>
          <Header />
          <div style={{ height: "80vh", }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                fontFamily: "Arvo",
                fontSize: "lg",
              }}
            >
              Home Page All Details
            </div>
            <div
              style={{
                height: "80vh",
                border: "1px solid black",
                margin: "10px",
                borderRadius: "10px",
                boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.5)",
                padding: "20px",
                backgroundColor:"#D5D8DC "
              }}
            >
              <VStack>
                <Center width={"100%"}>
                  <Box
                    boxShadow="dark-lg"
                    fontFamily={"Arvo"}
                    backgroundColor={"blue.400"}
                    color={"white"}
                    rounded="lg"
                    mx="10px"
                    p={"10px"}
                  >
                    <h5>Scholarship Test</h5>
                  </Box>
                </Center>
                <Divider h="2px" color="black" bgColor="black" mt="0Px" />
                <HStack spacing="10px" align="flex-end" >
                  <Box
                    boxShadow="dark-lg"
                    fontFamily="Arvo"
                    rounded="lg"
                    p="10px"
                    colorScheme="blue"
                    backgroundColor={"yellow.100"}
                  >
                    Total Application: {studentcount}
                  </Box>
                </HStack>
                <Center w="100%" display={{sm:"block",md:"block",lg:"flex"}} rounded={"lg"}>
                   
                    <ScholarshipModal
                      props={{
                        id: "6586a4846b479c3ecb63a8ba",
                        name: " 01 250",
                      }}
                    />
                    
                    <ScholarshipModal
                      props={{
                        id: "6586a50d6b479c3ecb63a8bc",
                        name: " 02 1000",
                      }}
                    />
                   
                  
                </Center>
                <Divider h="2px" color="black" bgColor="black" mt="0Px" />
                <HStack>
                <NotesAdd/>
                <AlumniAdd/>
                <Results/>
               
                </HStack>
              </VStack>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TeacherDashboard;
